import request from '@/utils/server.js'

// 查询用户列表
export function getUserListAPI(data) {
  return request({
    url: "/user/list",
    method: "get",
    params: data,
  });
}

// 新增用户
export function addUserAPI(data) {
  return request({
    url: "/user/add",
    method: "post",
    data,
  });
}

// 修改用户
export function updateUserAPI(data) {
  return request({
    url: "/user/update",
    method: "put",
    data,
  });
}

// 删除用户
export function deleteUserAPI(data) {
  return request({
    url: `/user/delete/${data.userId}`,
    method: "delete",
  });
}
